import { React, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AccountSettingsService from '../../../services/account-settings.service';
import { Alert } from '../../../services/notiflix.service';
import SearchableDropdown from '../SearchableDropdown';
import i18n from '../../../utils/i18n';
const UserProfileDetails = ({
  register,
  errors,
  clearErrors,
  userProfile,
  isBusiness,
  showMailField,
  setValue,
  countryId,
}) => {
  const defaultSearchData = {
    commonSearch: '',
    countryId: 0,
  };
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [searchData, setSearchData] = useState(defaultSearchData);
  const currentLang = i18n.language;

  const handleEntityChange = (e) => {
    const { name, value } = e.target;
    const upperCaseValue = value.toUpperCase();
    setValue(name, upperCaseValue, { shouldValidate: true });
  };
  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    if (countries.length > 0 && countryId) {
      const userCountry = countries.find((country) => country.id === countryId);
      if (userCountry) {
        setSelectedCountry({
          value: userCountry.id,
          label:
            currentLang === 'nl' ? userCountry.dutch_name : userCountry.name,
        });
      }
    }
  }, [countries, countryId, currentLang]);

  useEffect(() => {
    if (!isBusiness) {
      setValue('business_name', '');
      setValue('commerce_number', '');
      setValue('legal_entity_identifier', '');
      clearErrors('business_name');
      clearErrors('commerce_number');
      clearErrors('legal_entity_identifier');
    }
  }, [isBusiness, setValue]);
  const { t } = useTranslation('profile');
  const fetchCountries = async () => {
    try {
      const response = await AccountSettingsService.fetchCountries();

      if (response.status === 'failure') {
        Alert.error(response.message || 'Failed to fetch country list');
        return;
      }

      const countriesData = Array.isArray(response.data) ? response.data : [];
      setCountries(countriesData);
    } catch (error) {
      if (error instanceof Error) {
        Alert.error(error.message || 'Failed to fetch country list');
      } else {
        Alert.error('An unknown error occurred while fetching country list');
      }
    }
  };
  const handleCountrySelect = (option) => {
    setSelectedCountry(option);
    setValue('countryId', option ? option.value : 0, { shouldValidate: true });
    setSearchData({
      ...searchData,
      countryId: option ? option.value : 0,
    });
  };

  return (
    <div>
      <div>
        <h4 className="border-b border-[#ccc] mb-2 pb-2">
          {t('your_details')}
        </h4>
        <div className="mb-6 ">
          <p className="text-md text-[#85919F]">
            {t('review_update_personal_into')}
          </p>
        </div>
        <div className="w-full">
          <div className="common-grid">
            <div className="mb-4 md:mb-4 grif col-span-6 ">
              <input
                type="checkbox"
                checked={!!isBusiness}
                {...register('isBusiness')}
                id="isBusiness"
                className="w-auto"
              />
              <label htmlFor="isBusiness" className="text-sm md:text-md ml-2">
                {t('register_as_business')}
              </label>
            </div>
          </div>
          {/*  */}

          {isBusiness ? (
            <>
              <div className="col-span-6 emaildisbl">
                <div className="mb-6">
                  <p className="responsive-text">
                    {t('business_name')}
                    <span className="common-error-text">*</span>
                  </p>
                  <input
                    placeholder={t('business_name')}
                    type="text"
                    name="business_name"
                    className="overlay-background"
                    {...register('business_name', { required: true })}
                  />
                  <div className="common-error-text">
                    {errors.business_name?.message}
                  </div>
                </div>
              </div>
              <div className="col-span-12">
                <div className="common-grid">
                  <div className="mb-6 col-span-6">
                    <p className="responsive-text">
                      {t('chamber_of_commerce_number')}
                      <span className="common-error-text">*</span>
                    </p>
                    <input
                      placeholder="30134635"
                      type="text"
                      name="commerce_number"
                      className="overlay-background"
                      {...register('commerce_number', { required: true })}
                    />
                    <div className="common-error-text">
                      {errors.commerce_number?.message}
                    </div>
                  </div>
                  <div className="mb-6 col-span-6">
                    <p className="responsive-text">
                      {t('legal_entity_identification_number')}
                    </p>
                    <input
                      placeholder="506700GE1G29325QX363"
                      type="legal_entity_identifier"
                      name="legal_entity_identifier"
                      className="overlay-background"
                      {...register('legal_entity_identifier', {
                        required: true,
                      })}
                      onChange={handleEntityChange}
                    />
                    <div className="common-error-text">
                      {errors.legal_entity_identifier?.message}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : null}
          <div className="common-grid">
            <div className={`${!showMailField ? 'col-span-6' : 'col-span-4'}`}>
              <div className="mb-6">
                <p className="responsive-text">
                  {isBusiness ? t('contact_person') : t('full_name')}
                  <span className="common-error-text">*</span>
                </p>
                <input
                  placeholder="Peter Smith"
                  type="text"
                  className="overlay-background"
                  disabled={userProfile?.kyc_status === 1}
                  name="full_name"
                  {...register('full_name', { required: true })}
                />
                <div className="common-error-text">
                  {errors.full_name?.message}
                </div>
              </div>
            </div>
            {showMailField ? (
              <div className="col-span-4 emaildisbl">
                <div className="mb-6">
                  <p className="responsive-text">
                    {t('email_address')}
                    <span className="common-error-text">*</span>
                  </p>
                  <input
                    placeholder="demo@xyz.com"
                    type="email"
                    name="email"
                    className="overlay-background"
                    disabled={userProfile?.email ? true : false}
                    {...register('email', { required: true })}
                  />
                  <div className="common-error-text">
                    {errors.email?.message}
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
            {/*  */}
            <div className={`${!showMailField ? 'col-span-6' : 'col-span-4'}`}>
              <div className="mb-6">
                <div className="responsive-text">
                  {t('phone_number')}
                  <span className="common-error-text">*</span>
                </div>
                <input
                  placeholder="+3161231234"
                  type="text"
                  className="dark:bg-[#4c5972] dark:text-white"
                  name="phone_number"
                  {...register('phone_number', { required: true })}
                />
                <div className="common-error-text">
                  {errors.phone_number?.message}
                </div>
              </div>
            </div>
          </div>

          <div className="common-grid">
            <div className="col-span-6">
              <div className="">
                <p className="responsive-text">
                  {isBusiness ? t('business_address') : t('address')}
                </p>
                <input
                  placeholder={t('address')}
                  type="text"
                  name="address"
                  className="dark:bg-[#4c5972] dark:text-white"
                  {...register('address', { required: true })}
                />
                <div className="common-error-text">
                  {errors.address?.message}
                </div>
              </div>
            </div>
            <div className="col-span-6">
              <div className="">
                <div className="responsive-text">{t('postal_code')}</div>

                <input
                  placeholder="1003 AB"
                  type="text"
                  className="dark:bg-[#4c5972] dark:text-white"
                  name="postal_code"
                  {...register('postal_code')}
                />
                <div className="common-error-text">
                  {errors.postal_code?.message}
                </div>
              </div>
            </div>
            <div className="col-span-6">
              <div className="">
                <div className="responsive-text">{t('country')}</div>
                <SearchableDropdown
                  options={countries.map((country) => ({
                    value: country.id,
                    // label: country.name,
                    label:
                      currentLang === 'nl' ? country.dutch_name : country.name,
                  }))}
                  value={selectedCountry}
                  onChange={handleCountrySelect}
                  placeholder={t('country')}
                  error={errors.countryId?.message}
                />
              </div>
            </div>
            <div className="col-span-6">
              <div className="">
                <div className="responsive-text">{t('city')}</div>
                <input
                  placeholder="Amsterdam"
                  type="text"
                  className="dark:bg-[#4c5972] dark:text-white"
                  name="city"
                  {...register('city', { required: true })}
                />
                <div className="common-error-text">{errors.city?.message}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileDetails;
